// extracted by mini-css-extract-plugin
export default {"title":"oWIqEU1FcSZIqLl2WFIB"};